/* eslint-disable no-unused-expressions */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import GlobalForm from "../../../components/globalForm/GlobalForm";
import Loading from "../../../components/shared/loading/Loading";
import { updateData } from "../../../hooks/update";
import useFetch from "../../../hooks/useFetch";
import { apiPath, clientSideUrl } from "../../../utility/Constant";

const SelectionBannerPage = () => {
  const { selectionApi } = apiPath;
  const { clientSelection } = clientSideUrl;
  const [selectionData, selectionLoading] = useFetch(selectionApi);
  //
  if (selectionLoading) {
    return <Loading />;
  }

  const { image, title, sub_title, short_description, _id } = selectionData?.find(item => item.slug === "banner") || {};

  const data = [
    {
      elementType: "input",
      label: "Banner title",
      type: "Text",
      name: "title",
      defaultValue: title,
      required: false,
    },
    {
      elementType: "input",
      label: "Banner subtitle",
      type: "Text",
      name: "sub_title",
      defaultValue: sub_title,
      required: false,
    },
    {
      elementType: "textField",
      label: "short description",
      type: "Text",
      name: "short_description",
      defaultValue: short_description,
      required: false,
    },
    {
      elementType: "file",
      label: `Banner Image`,
      name: "image",
      type: "file",
      fullCol: true,
      defaultValue: image,
      required: false,
    },
    // {
    //   elementType: "richTextEditorV2",
    //   label: `for testing purpose`,
    //   name: "testing",
    //   type: "richTextEditorV2",
    //   defaultValue: "",
    //   required: false,
    // },
  ];

  const update = (data) => {
    const { image, ...rest } = data;
    rest.image = {
      url: image,
    };
    updateData(selectionApi, rest, _id);
    setTimeout(() => {
      window.location.reload();
    }, 800);
  };

  return (
    <div>
      <div className="mb-2 w-full text-right font-semibold text-sm">
        <Link
          className="text-black hover:text-[#DB0029]"
          to={clientSelection}
          target="_blank"
          rel="noopener noreferrer"
        >
          Visit page
          <span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="inline w-4 h-4 ml-1 align-text-top"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25"
              />
            </svg>
          </span>
        </Link>
      </div>
      <div className="bg-white p-5 shadow-md rounded-md border mt-5">

        <h1 className="md:ml-8 font-bold text-2xl mt-4  uppercase">
          banner content
        </h1>
        <GlobalForm data={data} update={update} />
      </div>
    </div>
  );
};

export default SelectionBannerPage;
